import React, { useState } from 'react';

const EyeIcon = ({ open = false }) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" className="secret-toggle-icon">
    {open ? (
      <>
        <path
          d="M2.25 12S5.25 6.75 12 6.75 21.75 12 21.75 12 18.75 17.25 12 17.25 2.25 12 2.25 12Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle
          cx="12"
          cy="12"
          r="3"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.7"
        />
      </>
    ) : (
      <>
        <path
          d="M3 3 21 21"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinecap="round"
        />
        <path
          d="M10.58 10.58A2 2 0 0 0 13.42 13.42"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.88 5.09A10.94 10.94 0 0 1 12 4.88C18.75 4.88 21.75 12 21.75 12A20.06 20.06 0 0 1 18.56 16.19M14.12 18.91A10.94 10.94 0 0 1 12 19.12C5.25 19.12 2.25 12 2.25 12A19.61 19.61 0 0 1 5.71 7.56"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </>
    )}
  </svg>
);

const PasswordField = ({ value, onChange, placeholder, autoComplete, ...rest }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className="password-field-wrap">
      <input
        type={visible ? 'text' : 'password'}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
        {...rest}
      />
      <button
        type="button"
        className="password-field-toggle"
        onClick={() => setVisible((prev) => !prev)}
        aria-label={visible ? 'Нууц үг нуух' : 'Нууц үг харуулах'}
      >
        <EyeIcon open={visible} />
      </button>
    </div>
  );
};

export default PasswordField;